import {connect} from 'formik'
import {formatCents} from 'shared'

export const FormikCents = connect(({precision = undefined, fields, formik}) => {
  const cents = fields.reduce((n, field) => n + formik.values[field], 0)

  return <span>{formatCents(cents, {precision})}</span>
})
